import Glide from '@glidejs/glide'


window.addEventListener('DOMContentLoaded', (event) => {
    //lookeen__testimonial-slider
    const testimonialSlider = document.querySelector('.lookeen__testimonial-slider');

    if (testimonialSlider) {
        new Glide(testimonialSlider, {
            type: 'carousel',
            perView:3,
            focusAt: 'center',
            gap: 30,
            autoplay: 5000,
            hoverpause: false,
            animationDuration: 1000,
            animationTimingFunc: 'ease-in-out',
            breakpoints: {
                768: {
                    perView: 1,
                    gap: 0
                }
            }
        }).mount();
    }

    const solutionsSlider = document.querySelector(".solutions__glide");
    if(solutionsSlider){
        new Glide(solutionsSlider ,{
            type: 'carousel',
            perView:3,
            focusAt: 'center',
            gap: 30,
            autoplay: 5000,
            hoverpause: false,
            animationDuration: 1000,
            animationTimingFunc: 'ease-in-out',
            breakpoints: {
                992: {
                    perView: 1,
                    gap: 0
                }
            }
        }).mount();
    }

        // get all the sliders .glide--hero
        const sliders = document.querySelectorAll('.glide--hero');

        // loop through each slider
        if(sliders){
            sliders.forEach(slider => {
                // get the slider's slides
                const slides = slider.querySelectorAll('.glide__slide');

                // create a new Glide instance
                new Glide(slider, {
                    type: 'carousel',
                    perView: 1,
                    gap: 0,
                    animationDuration: 1000,
                    animationTimingFunc: 'ease-in-out',
                }).mount();
            });
        }


});